var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSort = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#42526E",
  d: "m14.479 5.035 2.293 2.52c.486.534.143 1.445-.543 1.445H7.77c-.678 0-1.028-.91-.543-1.445l3.7-4.066a1.427 1.427 0 0 1 2.15 0zM7.77 15h8.455c.685 0 1.028.91.55 1.445l-3.7 4.066a1.426 1.426 0 0 1-2.149 0l-3.698-4.066C6.742 15.91 7.085 15 7.77 15"
})));
export default SvgSort;